<template>
  <vs-popup
    background-color="rgba(0,0,0,.6)"
    background-color-popup="rgb(248,248,248)"
    fullscreen
    :active.sync="isActiveLocal"
    title="Stok Hareketleri"
    v-esc="escape"
  >
    <vs-table ref="table" :data="stockLogs" :max-items="itemsPerPage">
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" vs-w="3.75">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-2/12">
          <vs-button
            class="weight-600 p-1"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'created' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('created')"
            >Tarih</vs-button
          >
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="weight-600 p-1"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'stock.RawMaterial.StockCode'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('stock.RawMaterial.StockCode')"
            >Kod</vs-button
          >
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="weight-600 p-1"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'stock.RawMaterial.Name'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('stock.RawMaterial.Name')"
            >İsim</vs-button
          >
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="weight-600 p-1"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'unitPartQuantity' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('unitPartQuantity')"
            >Miktar</vs-button
          >
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="weight-600 p-1"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'buyPrice' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('buyPrice')"
            >Maaliyet</vs-button
          >
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="weight-600 p-1"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'oldBuyPrice' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('oldBuyPrice')"
            >Eski Maaliyet</vs-button
          >
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="weight-600 p-1"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'stock.RawMaterial.Supplier.Name'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('stock.RawMaterial.Supplier.Name')"
            >Tedarikçi</vs-button
          >
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-2/12">
              <p class="text-center">{{ tr.dateTime }}</p>
            </vs-td>

            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.stock.rawMaterial.stockCode }}</p>
            </vs-td>

            <vs-td class="w-2/12">
              <p class="text-center">{{ tr.stock.rawMaterial.name }}</p>
            </vs-td>

            <vs-td class="w-2/12">
              <p class="text-center m-auto" style="width: fit-content">
                <vs-chip :color="getLogColor(tr.type)"
                  >{{ tr.unitPartQuantity }} {{ tr.unitName }}
                </vs-chip>
              </p>
            </vs-td>

            <vs-td class="w-2/12">
              <p class="text-center m-auto" style="width: fit-content">
                <vs-chip color="primary">
                  {{ $toCurrency(tr.buyPrice) }}
                </vs-chip>
                <vs-chip color="transparent text-dark"
                  >%{{ tr.stock.rawMaterial.kdv }}</vs-chip
                >
              </p>
            </vs-td>
            <vs-td class="w-2/12">
              <p class="text-center m-auto" style="width: fit-content">
                <vs-chip color="primary">
                  {{ $toCurrency(tr.oldBuyPrice) }}
                </vs-chip>
              </p>
            </vs-td>

            <vs-td class="w-1/12">
              <p class="text-center">
                {{ tr.stock.rawMaterial.supplier.name }}
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </vs-popup>
</template>

<script>
import GlobalFilter from "../GlobalFilter";
import PaginationDefault from "../PaginationDefault";
import moduleStockLog from "@/store/stockLog/moduleStockLog.js";

export default {
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    PaginationDefault,
    GlobalFilter,
  },
  data() {
    return {
      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,

      isFilterActive: false,
      filterOptions: [
        "branch",
        "stock",
        "quantity",
        "cost",
        "oldCost",
        "supplier",
        "dateRange",
        "timeRange",
        "stockCode",
        "stockLogType",
        "unit",
      ],
      filterOptionNames: [
        "Şube",
        "Stok",
        "Miktar",
        "Maaliyet",
        "Eski Maaliyet",
        "Tedarikçi",
        "Tarih",
        "Saat",
        "Stok Kodu",
        "Tip",
        "Birim",
      ],
      filterChips: [],
    };
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
    },
    stockLogs() {
      return this.$store.state.stockLog.stockLogs;
    },
    totalDataRow() {
      return this.$store.state.stockLog.totalDataRow;
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
  },
  methods: {
    getLogColor(type) {
      switch (type) {
        case 1:
          return "danger";
        case 2:
          return "success";
        case 3:
          return "dark";
      }
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branch: this.$currentUser.branch,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
        cost: {
          min: null,
          max: null,
        },
        oldCost: {
          min: null,
          max: null,
        },
        quantity: {
          min: null,
          max: null,
        },
        stock: null,
        supplier: null,
        unit: null,
        stockCode: null,
        type: null,
        unitName: null,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    escape() {
      if (this.isActiveLocal == true && this.isActiveFilter == false)
        this.isActiveLocal = false;
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    getStockLogList: function () {
      this.$store
        .dispatch("stockLog/fetchDataListItemsStockLog", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          this.tableOptions.sortBy = val;
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          this.tableOptions.sortBy = val;
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
          break;
      }
    },
  },
  created() {
    if (!moduleStockLog.isRegistered) {
      this.$store.registerModule("stockLog", moduleStockLog);
      moduleStockLog.isRegistered = true;
    }
    this.clearFilter();
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        this.getStockLogList();
      },
    },
    isActive: function (val) {
      val == true ? this.getStockLogList() : null;
    },
    currentPage: function () {
      this.tableOptions.pageIndex = this.currentPage;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
    },
  },
};
</script>

<style></style>
